// Which ad link (/go/<slug>) brought this visitor, kept for 30 days so an
// order placed later can be credited to it (sent with each cart item).

const KEY = 'itsasimcha_ad_source';
const WINDOW_MS = 30 * 86400000;

export function rememberAdSource(slug) {
  try { window.localStorage.setItem(KEY, JSON.stringify({ slug, at: Date.now() })); } catch (_) { /* private mode */ }
}

export function currentAdSource() {
  try {
    const v = JSON.parse(window.localStorage.getItem(KEY) || 'null');
    if (v && v.slug && Date.now() - Number(v.at) < WINDOW_MS) return v.slug;
  } catch (_) { /* ignore */ }
  return undefined;
}
